<template>
  <div>
    <b-modal ref="modal" size="dm" hide-footer title="Send status by email">
      <div class="d-block">
        <div>
          <dl class="row mb-3">
            <dt class="col-sm-3 mb-0">Lead Id</dt>
            <dd class="col-sm-9 mb-0">
              {{ row.id }}
            </dd>
            <dt class="col-sm-3 mb-0">Client Name</dt>
            <dd class="col-sm-9 mb-0">
              {{ row.client_first_name }} {{ row.client_last_name }}
            </dd>
            <dt class="col-sm-3 mb-0">Client Email</dt>
            <dd class="col-sm-9 mb-0">
              {{ row.client_email }}
            </dd>
            <dt class="col-sm-3 mb-0">BDM</dt>
            <dd class="col-sm-9 mb-0">
              {{ row.createdBy }}
            </dd>
          </dl>

          <p class="text-danger">
            Do you need to send notification to client via email?
          </p>
          <div class="text-right">
            <button class="btn btn-sm btn-secondary mr-2" @click="hideModal()">
              No
            </button>
            <button class="btn btn-sm btn-success" @click="sendNotification">
              <b-spinner v-if="isSpinner" small class="mr-2"></b-spinner>Yes
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import * as notificationService from '../../services/notification.service'
import * as messageService from '../../services/message.service'
export default {
  name: 'ModalEmailSendingConfirmation',
  props: ['recordId', 'row'],
  components: {},
  data() {
    return { isSpinner: false }
  },
  computed: {},
  methods: {
    hideModal() {
      this.$refs.modal.hide()
    },
    showModal() {
      this.$refs.modal.show()
    },

    sendNotification: async function () {
      this.isSpinner = true

      try {
        const response = await notificationService.leadsSendStatusUpdate({
          leadsId: this.recordId
        })

        this.hideModal()

        messageService.fnSweetAlertSuccessToast(
          'Email Notification',
          'Sent successfully'
        )

        this.isSpinner = false
      } catch (error) {
        switch (error.response.status) {
          case 422:
            this.errors = error.response.data.errors
            break

          case 500:
            messageService.fnSweetAlertErrorToast(
              'Email Notification',
              error.response.data.message
            )
            break

          default:
            messageService.fnSweetAlertErrorToast(
              'Email Notification',
              'Something wrong'
            )
            break
        }
        this.isSpinner = false
      }
    }
  }
}
</script>
